import { Stage, StageList } from "@/models/stage";
import { AppConfig } from "@/config/app.config";

interface StagesData {
  [stageNumber: string]: Stage;
}

export const getAllStagesData = async (userBatch?: string): Promise<StageList> => {
  try {
    // Priority: 1) User's batch (from Firestore), 2) localStorage, 3) default
    const selectedBatch = userBatch || localStorage.getItem("selectedBatch") || AppConfig.DEFAULT_BATCH;

    // Get the stages file for the selected batch from config
    const batchConfig = AppConfig.BATCHES[selectedBatch];
    if (!batchConfig) {
      throw new Error(`Batch "${selectedBatch}" not found in configuration`);
    }

    // Fetch the stages data
    const stagesResponse = await fetch(`/data/${batchConfig.stagesFile}`);
    const stagesData: StagesData = await stagesResponse.json();

    // Transform the object structure to array with id field
    const stagesList: StageList = Object.entries(stagesData).map(([stageNumber, stageData]) => ({
      ...stageData,
      id: stageNumber, // Use stage_number as the id
    }));

    // Sort by stage_number for consistency
    stagesList.sort((a, b) => a.stage_number - b.stage_number);

    return stagesList;
  } catch (error) {
    console.error("Error loading stages data:", error);
    throw error;
  }
};
